import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetDirigidoTramite } from '../../shared/interfaces/database/evento';

@Injectable({
  providedIn: 'root'
})
export class DirigidoTramiteService {
  private readonly baseUrl = `${environment.apiUrl}/api/dirigido-tramite`;

  constructor(private http: HttpClient) { }

  getDirigidoTramite(): Observable<IGetDirigidoTramite[]> {
    return this.http.get<IGetDirigidoTramite[]>(`${this.baseUrl}`);
  }
}
